module.exports = "<div class=\"main-content\">\n  <div class=\"container-fluid\">\n    <div class=\"row\">\n      <div class=\"col-md-4\">\n        <div class=\"card\">\n          <div class=\"card-header\" data-background-color=\"red\">\n            <h4 class=\"title\">Смена пароля</h4>\n          </div>\n          <new-password-form #newPassword [isChangePassword]=\"true\" (onSubitPasswordClick)=\"changePassword($event)\"></new-password-form>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /app/SPA/src/app/client/profile/profile.component.html
// module id = ../../../../../src/app/client/profile/profile.component.html
// module chunks = 0